import type { FaireThemeEntity } from "../../entity_types/theme";

export const salon_retail_staples: FaireThemeEntity = {
  token: "salon-retail-staples",
  type: "theme",
  name: "Salon Retail Staples",
  description: "Turn services into recurring product revenue -- take-home routine products increase repeat visits and basket size at checkout",
  teaser: "",
  detail: "",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_b57ayww6fk",
    "p_m9k4junmbp",
    "p_nzvud66ryn",
    "p_qp6u6wanz4",
    "p_1m77f60fmt",
    "p_e7ntwa7s8m",
    "p_ha7v2janew",
    "p_ckqwke8hja",
    "p_nj6wjp89dr",
    "p_r2s3wgcdac",
    "p_5ngtaerd9j",
    "p_4nbge47wva",
    "p_rhkx928vvd",
    "p_2ru57h5q8p",
    "p_wg8njj3mcs",
    "p_2axyu8u4mx",
    "p_dmth74n6wt",
    "p_zbdjhy5gcf",
    "p_cst8bpsuqs",
    "p_45ksdjtpvs",
    "p_8vumepf6wk",
    "p_v2u2uj8h9s",
    "p_fektd9jcp3",
    "p_9n6mp50z67",
    "p_adpe2yzfxj",
    "p_x6jyzjsyk5",
    "p_6yvyd9v679",
    "p_k62hp8ztbg",
    "p_39rkzwtu63",
    "p_tkfbhjfcwx",
    "p_nstjbnpwkv",
    "p_qv7jpzsb4n",
    "p_yb33ajfppb",
    "p_mdg65zeq7t",
    "p_5wex25zkj7",
    "p_p9gy726jgu",
    "p_b6ql8m70l6",
    "p_wdcf7kv4an",
    "p_zp9xxth5ss",
    "p_42cw3y53aj",
    "p_8d4fmqshpx",
    "p_u5ua8vpxxh",
    "p_9qgtgq96c8",
    "p_n9mfa3cuu4",
    "p_yhjamy2pjq",
    "p_44h74dp64s",
    "p_bbwb8tkmam",
    "p_hw3da87pv7",
    "p_yw3h7vwthk",
    "p_d6s3mzfcgn",
    "p_subp5g8e6d",
    "p_hb6aqvbd64",
    "p_mnyvnsg9a2",
    "p_27bjtjf6pn",
    "p_2m2sh6d24u",
    "p_fmf4b5n7fu",
    "p_v58xruvbv3",
    "p_yy97ha4dcz",
    "p_2au4zys6qz",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
